import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Observable } from 'rxjs';
import { PAGE_SIZE_OPTIONS } from '../../../helpers/table.helper';
import { MatSort, Sort } from "@angular/material/sort";
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Zones, ZonesFilters } from '../../../commons/models/zone';

export type ZonesColumns = ["start_time","end_time", "day_of_week", "active", "actions"];

@Component({
    selector: 'app-zones-list',
    templateUrl: './zones-list.component.html',
    styleUrls: ['./zones-list.component.scss']
})
export class ZonesListComponent{
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    @Input()
    zones: Zones

    @Input()
    selectedZone: Zones[];

    @Input()
    defaultFilters: ZonesFilters;

    pageSizeOptions = PAGE_SIZE_OPTIONS;
    expandedElement: Zones | null;

    @Input()
    total: Observable<number>;

    @Input()
    displayedColumns: string[] = ["name", "shipping_cost", "radius", "latitude", "longitude", "tenant_id", "actions"];

    @Input() canAdd: boolean;
    @Input() canEdit: boolean;
    @Input() canSelect: boolean;

    @Output()
    onLoad: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    onSortChange: EventEmitter<Sort> = new EventEmitter<Sort>();
    @Output()
    onPageChange: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
    @Output()
    onFilterChange: EventEmitter<ZonesFilters> = new EventEmitter<ZonesFilters>();

    @Output()
    onSelectZones : EventEmitter<Zones> = new EventEmitter<Zones>();
    @Output()
    onAddZones: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    onEditZones: EventEmitter<Zones> = new EventEmitter<Zones>();
    @Output()
    onShowZones: EventEmitter<Zones> = new EventEmitter<Zones>();
    @Output()
    onAddSelectedZone: EventEmitter<Zones> = new EventEmitter<Zones>();
    @Output()
    onRemoveSelectedZone: EventEmitter<Zones> = new EventEmitter<Zones>();
    // @Output()
    // onDeleteZone: EventEmitter<Zones> = new EventEmitter<Zones>();


    get selectedItems(): boolean {
        return this.selectedZone.length > 0;
    }

    ngAfterViewInit() {
        setTimeout(() => {
          if (this.sort) {
            this.sort.sortChange.subscribe((sort) => {
              this.onSortChange.emit(sort);
            });
          } else {
            console.error("MatSort non è stato inizializzato! Controlla il template.");
          }
        }, 0);
    }

    addZone() {
      this.onAddZones.emit();
    }

    editZone(zones: Zones) {
        this.onEditZones.emit(zones);
    }

    // deleteZone(zones: Zones){
    //   this.onDeleteZone.emit(zones);
    // }

    selectZone(zones: Zones) {
    this.onSelectZones.emit(zones);
    }

    removeSelectedZone(zones: Zones) {
    this.onRemoveSelectedZone.emit(zones)
    }

    onFilter(filters: ZonesFilters) {
        this.paginator.firstPage();
        this.onFilterChange.emit(filters);
    }


    showZone(activityList: Zones) {
        this.onShowZones.emit(activityList);
    }

    getTenant(zone: Zones): string {
      if (!zone.tenant) {
        return 'N/A';
      }
      return zone.tenant.name
    }
}
